import lightbox from 'lightbox2/dist/js/lightbox';

export default {
  init() {
    lightbox.option({
      showImageNumberLabel: false
    })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init function

  },

};
